import AccountManagement from "./AccountManagement";

export default AccountManagement;
